import _ from 'lodash'
import React, { useMemo, useState } from 'react'
import { AutocompleteInput } from '../../../Components/Inputs/AutocompleteInput'
import { InputOptionProps } from '../../../Components/Inputs/Types'
import { AppPermission, useAppPermissions } from '../../../Hooks/useAppPermissions'
import { ConsigneeType } from '../../../Schema/ConsigneeSchema'
import { ServiceSchema } from '../../../Schema/ServiceSchema'
import { useServicesSelector } from '../Hooks/useServicesSelector'
import { ServiceAddDrawer } from '../ServiceAddDrawer'

interface ServicePickerProps {
  consigneeType?: ConsigneeType
  value?: string
  className?: any
  label?: string
  helperText?: string
  onChange: (value: string) => void
  disabled?: boolean
  required?: boolean
  variant?: 'standard' | 'filled' | 'outlined'
  placeholder?: string
  freeSolo?: boolean
  noOptionsText?: string
  clearOnBlur?: boolean
  onCreateNew?: (text: string) => void
  enableCreate?: boolean
  error?: boolean
  showAvatar?: boolean
}

export const ServicePicker: React.FC<ServicePickerProps> = ({
  consigneeType,
  className,
  value,
  label,
  helperText,
  onChange,
  disabled,
  required,
  variant,
  placeholder,
  freeSolo,
  noOptionsText,
  clearOnBlur,
  enableCreate = true,
  error,
  showAvatar = false,
}) => {
  const { checkPermissions } = useAppPermissions()

  const [openAdd, setOpenAdd] = useState(false)
  const [text, setText] = useState<string>('')

  const entities = useServicesSelector()

  const filteredEntities = useMemo(() => {
    if (!consigneeType) {
      return _.map(entities)
    }
    return _.filter(entities, c => c.type === consigneeType)
  }, [entities, consigneeType])

  const options: InputOptionProps[] = useMemo(() => {
    return _.map(filteredEntities, c => c.getInputOption())
  }, [filteredEntities])

  const handleOnCreate = (name?: string) => {
    setOpenAdd(true)
    setText(
      name,
    )
  }

  const handleOnCloseAdd = (schema?: ServiceSchema) => {
    if (schema) {
      onChange(schema.id)
    }
    setOpenAdd(false)
  }
  return (
    <>
    <AutocompleteInput
      value={value}
      className={className}
      label={label}
      helperText={helperText}
      onChange={value => onChange(value as string)}
      disabled={disabled}
      required={required}
      variant={variant}
      placeholder={placeholder}
      freeSolo={freeSolo}
      options={options}
      noOptionsText={noOptionsText}
      clearOnBlur={clearOnBlur}
      onCreateNew={handleOnCreate}
      enableCreate={checkPermissions([AppPermission.ServiceAdd]) && enableCreate}
      error={error}
      showAvatar={showAvatar}
    />
    {openAdd && <ServiceAddDrawer
      open={openAdd}
      onClose={handleOnCloseAdd}
      defaultData={{
        name: text,
        type: consigneeType,
      }}
    />}
    </>
  )
}
